
      import 'https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.18.0/cdn/components/qr-code/qr-code.js';
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-event-propagator';

      const ropeMode = document.querySelector('input[type="checkbox"]');

      ropeMode.addEventListener('input', () => {
        document.body.toggleAttribute('rope-mode');
      });
    